import setup from './moduleSetup';

export default {
    name: 'products',
    before: [],
    after: [],
    setup,
};
